export default "__VITE_ASSET___LiGBurm__"